// extracted by mini-css-extract-plugin
export default {"maxHeight":"SpecifCategory_maxHeight__8+phh"};